import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type DisputeArMoveMutationVariables = Types.Exact<{
  moveId: Types.Scalars['bigint']['input'];
  disputed: Types.Scalars['Boolean']['input'];
  disputeReason: Types.Scalars['String']['input'];
}>;


export type DisputeArMoveMutation = { __typename?: 'mutation_root', update_moves?: { __typename?: 'moves_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'moves', id: number, disputed: boolean, dispute_reason?: string | null, updatedat?: string | null }> } | null, update_armoves?: { __typename?: 'armoves_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'armoves', id: number, move_id?: number | null, disputed: boolean, dispute_reason?: string | null, updatedat?: string | null }> } | null };


export const DisputeArMoveDocument = gql`
    mutation disputeARMove($moveId: bigint!, $disputed: Boolean!, $disputeReason: String!) {
  update_moves(
    where: {id: {_eq: $moveId}}
    _set: {disputed: $disputed, dispute_reason: $disputeReason, updatedat: "now()"}
  ) {
    affected_rows
    returning {
      id
      disputed
      dispute_reason
      updatedat
    }
  }
  update_armoves(
    where: {move_id: {_eq: $moveId}}
    _set: {disputed: $disputed, dispute_reason: $disputeReason, updatedat: "now()"}
  ) {
    affected_rows
    returning {
      id
      move_id
      disputed
      dispute_reason
      updatedat
    }
  }
}
    `;
export type DisputeArMoveMutationFn = Apollo.MutationFunction<DisputeArMoveMutation, DisputeArMoveMutationVariables>;

/**
 * __useDisputeArMoveMutation__
 *
 * To run a mutation, you first call `useDisputeArMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisputeArMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disputeArMoveMutation, { data, loading, error }] = useDisputeArMoveMutation({
 *   variables: {
 *      moveId: // value for 'moveId'
 *      disputed: // value for 'disputed'
 *      disputeReason: // value for 'disputeReason'
 *   },
 * });
 */
export function useDisputeArMoveMutation(baseOptions?: Apollo.MutationHookOptions<DisputeArMoveMutation, DisputeArMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisputeArMoveMutation, DisputeArMoveMutationVariables>(DisputeArMoveDocument, options);
      }
export type DisputeArMoveMutationHookResult = ReturnType<typeof useDisputeArMoveMutation>;
export type DisputeArMoveMutationResult = Apollo.MutationResult<DisputeArMoveMutation>;
export type DisputeArMoveMutationOptions = Apollo.BaseMutationOptions<DisputeArMoveMutation, DisputeArMoveMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (update_moves, update_armoves): returns the full response object.
 * @source {@link src/features/invoices/queries/disputeARMove.mutation.gql}
 */
export async function disputeARMove(
  variables: DisputeArMoveMutationVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<DisputeArMoveMutation> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).mutate<DisputeArMoveMutation>(
    DisputeArMoveDocument,
    variables,
    requestOptions
  )
}